export default [
  {
    name: "Display and Position",
    properties: [
      {
        name: "Display",
        value: "display",
        type: "text",
        autocomplete: [
          "block",
          "inline",
          "grid",
          "flex",
          "table",
          "inline-block",
          "inline-grid",
          "inline-flex",
          "inline-table",
          "list-item",
          "table-caption",
          "table-column-group",
          "table-header-group",
          "table-footer-group",
          "table-row-group",
          "table-cell",
          "table-column",
          "table-row",
          "none",
          "initial",
          "inherit",
          "contents",
        ],
      },
      {
        name: "Position",
        value: "position",
        type: "text",
        autocomplete: ["relative", "absolute", "fixed", "static", "sticky", "initial", "inherit"],
      },
      {
        name: "Top",
        value: "top",
        type: "length",
        autocomplete: ["auto", "inherit", "initial"],
      },
      {
        name: "Right",
        value: "right",
        type: "length",
        autocomplete: ["auto", "inherit", "initial"],
      },
      {
        name: "Bottom",
        value: "bottom",
        type: "length",
        autocomplete: ["auto", "inherit", "initial"],
      },
      {
        name: "Left",
        value: "left",
        type: "length",
        autocomplete: ["auto", "inherit", "initial"],
      },
      {
        name: "Float",
        value: "float",
        type: "text",
        autocomplete: ["none", "left", "right", "initial", "inherit", "inline-start", "inline-end"],
      },
      {
        name: "Clear Float",
        value: "clear",
        type: "text",
        autocomplete: ["none", "left", "right", "both", "initial", "inherit", "inline-start", "inline-end"],
      },
      {
        name: "Stack Order",
        value: "z-index",
        type: "number",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Visibility",
        value: "visibility",
        type: "text",
        autocomplete: ["visible", "hidden", "initial", "inherit"],
      },
      {
        name: "Writing Mode",
        value: "writing-mode",
        type: "text",
        autocomplete: ["horizontal-tb", "vertical-rl", "vertical-lr"],
      },
    ],
  },
  {
    name: "Size and Spacing",
    properties: [
      {
        name: "Width",
        value: "width",
        type: "length",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Height",
        value: "height",
        type: "length",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Minimal Width",
        value: "min-width",
        type: "length",
        autocomplete: ["none", "initial", "inherit"],
      },
      {
        name: "Minimal Height",
        value: "min-height",
        type: "length",
        autocomplete: ["none", "initial", "inherit"],
      },
      {
        name: "Maximal Width",
        value: "max-width",
        type: "length",
        autocomplete: ["none", "initial", "inherit"],
      },
      {
        name: "Maximal Height",
        value: "max-height",
        type: "length",
        autocomplete: ["none", "initial", "inherit"],
      },
      {
        name: "Margin",
        value: "margin",
        type: "length",
      },
      {
        name: "Top Margin",
        value: "margin-top",
        type: "length",
        shorthand: "margin",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Right Margin",
        value: "margin-right",
        type: "length",
        shorthand: "margin",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Bottom Margin",
        value: "margin-bottom",
        type: "length",
        shorthand: "margin",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Left Margin",
        value: "margin-left",
        type: "length",
        shorthand: "margin",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Padding",
        value: "padding",
        type: "length",
      },
      {
        name: "Top Padding",
        value: "padding-top",
        type: "length",
        shorthand: "padding",
        autocomplete: ["initial", "inherit"],
      },
      {
        name: "Right Padding",
        value: "padding-right",
        type: "length",
        shorthand: "padding",
        autocomplete: ["initial", "inherit"],
      },
      {
        name: "Bottom Padding",
        value: "padding-bottom",
        type: "length",
        shorthand: "padding",
        autocomplete: ["initial", "inherit"],
      },
      {
        name: "Left Padding",
        value: "padding-left",
        type: "length",
        shorthand: "padding",
        autocomplete: ["initial", "inherit"],
      },
      {
        name: "Box Size",
        value: "box-sizing",
        type: "text",
        autocomplete: ["content-box", "border-box", "initial", "inherit"],
      },
      {
        name: "Overflow",
        value: "overflow",
        type: "text",
        autocomplete: ["visible", "hidden", "scroll", "auto", "initial", "inherit"],
      },
    ],
  },
  
  {
    name: "Logical Properties",
    properties: [
      {
        name: "Block Size",
        value: "block-size",
        type: "length",
        autocomplete: ["auto", "max-content", "min-content", "fit-content", "inherit", "initial"],
      },
      {
        name: "Inline Size",
        value: "inline-size",
        type: "length",
        autocomplete: ["auto", "max-content", "min-content", "fit-content", "inherit", "initial"],
      },
      {
        name: "Minimal Block Size",
        value: "min-block-size",
        type: "length",
        autocomplete: ["max-content", "min-content", "fit-content", "inherit", "initial"],
      },
      {
        name: "Minimal Inline Size",
        value: "min-inline-size",
        type: "length",
        autocomplete: ["max-content", "min-content", "fit-content", "inherit", "initial"],
      },
      {
        name: "Maximal Block Size",
        value: "max-block-size",
        type: "length",
        autocomplete: ["auto", "max-content", "min-content", "fit-content", "inherit", "initial"],
      },
      {
        name: "Maximal Inline Size",
        value: "max-inline-size",
        type: "length",
        autocomplete: ["auto", "max-content", "min-content", "fit-content", "inherit", "initial"],
      },
      {
        name: "Margin Block",
        value: "margin-block",
        type: "length",
      },
      {
        name: "Margin Block Start",
        value: "margin-block-start",
        type: "length",
        shorthand: "margin-block",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Margin Block End",
        value: "margin-block-end",
        type: "length",
        shorthand: "margin-block",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Margin Inline",
        value: "margin-inline",
        type: "length",
      },
      {
        name: "Margin Inline Start",
        value: "margin-inline-start",
        type: "length",
        shorthand: "margin-inline",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Margin Inline End",
        value: "margin-inline-end",
        type: "length",
        shorthand: "margin-inline",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Padding Block",
        value: "padding-block",
        type: "length",
      },
      {
        name: "Padding Block Start",
        value: "padding-block-start",
        type: "length",
        shorthand: "padding-block",
        autocomplete: ["initial", "inherit"],
      },
      {
        name: "Padding Block End",
        value: "padding-block-end",
        type: "length",
        shorthand: "padding-block",
        autocomplete: ["initial", "inherit"],
      },
      {
        name: "Padding Inline",
        value: "padding-inline",
        type: "length",
      },
      {
        name: "Padding Inline Start",
        value: "padding-inline-start",
        type: "length",
        shorthand: "padding-inline",
        autocomplete: ["initial", "inherit"],
      },
      {
        name: "Padding Inline End",
        value: "padding-inline-end",
        type: "length",
        shorthand: "padding-inline",
        autocomplete: ["initial", "inherit"],
      },
      {
        name: "Inset Block",
        value: "inset-block",
        type: "length",
      },
      {
        name: "Inset Block Start",
        value: "inset-block-start",
        type: "length",
        shorthand: "inset-block",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Inset Block End",
        value: "inset-block-end",
        type: "length",
        shorthand: "inset-block",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Inset Inline",
        value: "inset-inline",
        type: "length",
      },
      {
        name: "Inset Inline Start",
        value: "inset-inline-start",
        type: "length",
        shorthand: "inset-inline",
        autocomplete: ["auto", "initial", "inherit"],
      },
      {
        name: "Inset Inline End",
        value: "inset-inline-end",
        type: "length",
        shorthand: "inset-inline",
        autocomplete: ["auto", "initial", "inherit"],
      },
    ],
  },
];
